import React from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { SiCashapp } from 'react-icons/si';

import './dialogPagamento.css';

export default function DialogSuccessPagamentoCartao({ openDialog, setOpenDialog }) {
    const close = () => {
        window.location.reload();
    };

    const footer = (
        <div>
            <Button label="Ok" icon="pi pi-check" onClick={close} />
        </div>
    );

    return (
        <Dialog
            header="Pagamento Realizado com sucesso"
            footer={footer}
            visible={openDialog}
            style={{ width: '50vw' }}
            modal
            onHide={close}
        >
            <div className="dialog-pagamento-content">
                <SiCashapp color="green" fontSize={50} />
                <h2>Pagamento Realizado com Sucesso!</h2>
            </div>
        </Dialog>
    );
}
